module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page07"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Chapter One")])])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page07"
    }
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Shana Parisi knew better than to leave the well-marked cross-country ski trail in the mountains outside Leadville. Above all, she believed in following the rules. Her logical, predictable nature served her well in her work as an exploration geologist for AMVOX Oil.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But today was somehow different. Acting on impulse, she’d stepped off the marked trail and gone exploring. Ignoring the beginning twinges of a headache, she’d skied from one interesting geological feature to another. These mineral-rich mountains were like a trip to Disneyland, especially since she’d spent the past year and a half on assignment in Kuwait. Colorado felt so clean, so fresh, so incredibly all-American.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page07"
    }
  }, [_vm._v("She poked around the edges of an open pit mine. Studied the striation on a granite cliff. And entered a natural cave pocked with dark crystals, several of ")]), _c('a', {
    attrs: {
      "id": "page08"
    }
  }, [_vm._v("which found their way into her pocket along with an unusual shard of glassy green that looked like trinite.")])]), _c('a', {
    attrs: {
      "id": "page08"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Outside the cave, she slipped her boots into the bindings of her short backcountry skis, fastened the tethers and inhaled a gasp of the thin mountain air. Her lungs burned. Glancing at her wristwatch, she saw that she’d been out here for over three hours. Too long. Her slight headache had turned into a real killer.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Adjusting her goggles, she peered downhill at a wide slope bordered by thick pine forest on either side and tried to remember where she’d left the cross-country trail. Downhill to the left. Or to the right? Every year dozens of people got lost in these mountains. Some were never found.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Surely, she hadn’t gone too far off track. Reaching up, she tightened the scrunchie that held her thick black hair up in a ponytail. Earlier, she’d taken off her heavy gloves and parka; the May weather was warm enough for skiing in just a down vest and turtleneck.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It was colder now. Heavy gray clouds roiled overhead, and darker clouds were coming in behind them. Snowflakes fell in nasty little sputters. Should she dig her warmer gear out of her backpack? Making that simple decision seemed difficult; the inside of her head was fuzzy. Something was wrong with her. Maybe altitude sickness. She was near the Continental Divide, over ten thousand feet. She needed to get off this mountain.")])]), _c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Though tempted to tuck into a ball and schuss downhill like an Alpine skier, she wasn’t that skilled. Carefully, she traversed the ridge above the snow-covered slope. It took all of her concentration to coordinate thrusting with her skis and picking with her poles.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A fierce wind gusted around her, taking her breath away. A strange glow surrounded her—like a spotlight from the heavens. The wind became a deafening roar. Her body was weightless, disconnected. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("What’s happening?")]), _vm._v(" She blinked slowly and everything returned to normal.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Then, the storm hit hard. An instant blizzard. The heavens split open and dumped a truckload of snow on her head.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her goggles smeared with moisture, and she could barely see. The freezing cold sank through her turtleneck and into her bones as she kept going. Though she was skiing furiously across the ridge, it felt as if she was standing still, suspended in the storm.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Turning to dig in with her edges, her skis stuttered across a patch of ice then slipped out from under her. A scream wrenched from her throat as she went flying. Her boots broke free from the bindings, and she released the poles. In a somersault, she landed on her backpack and slid downhill. Her skis, still attached by tethers, crashed beside her. She dug in the heels of her boots, fighting until finally she came to a stop.")])]), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("When she struggled to stand, her feet sank deep into the snowpack, and she sprawled backward. With her heart beating rapidly, she couldn’t catch her breath. She was dizzy, light-headed. The entire world was shrouded in white. And cold. God, it was cold.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Forcing herself up, she lurched and stumbled again, falling forward on her hands and knees. A wave of nausea surged in her belly. She vomited into the snow.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She needed to pull herself together, but she couldn’t move. Did she hit her head when she fell? Was she paralyzed? More likely, she was in early stage hypothermia. A seductive lassitude. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("This is what happens when you break the rules.")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It occurred to her that she might die. Alone. Unmarried and without children. There would be no one to mourn her passing except for her globe-trotting diplomat father whose greatest concern would be to choose the most appropriate coffin.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She lay back in the snow, too cold to care what happened to her. The roaring winds swept over her. In their wake came confusion. And then, a strong sense of certainty. She was meant to be here at this place and in this time. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("This is my destiny.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_vm._v("Through the swirling eddies of snow, she saw him. A man dressed in white from head to toe—camouflaged in the storm. Though he was skiing uphill against the pelting wind, he moved with great speed, driving his long skis forward. His technique amazed ")]), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_vm._v("her. This guy was an incredible Nordic skier. A real athlete.")])]), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("By the time she forced herself to sit up, he was beside her. She peered up at him. “Who are you?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Sergeant Luke Rawlins, 10th Mountain Division.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A soldier? Though she was dizzy and weak, she cracked a smile. It seemed that the cavalry had skied over the hill and come to her rescue. His head was covered by the white hood of his fur-lined parka. His eyes were hidden behind goggles. All she could see of his face was a firm, stubborn jaw.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("With a huge effort, she stood upright, knee-deep in snow. Her legs felt like rubber. The cold had drained the last bit of strength from her muscles.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Before she could tell him that she was fine, her eyelids closed. She was falling through the whirling snow into unconsciousness.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("I"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("N HIS ONE-ROOM CABIN")]), _vm._v(", Luke pulled the wet turtleneck up and over her head. She wasn’t wearing a bra. Though his purpose in stripping off her wet clothes was to get her dried off and warmed up, he couldn’t help looking. Her body was slim, but she curved in all the right places. The flare from her slender waist to her hips was sheer perfection. Her olive skin was smooth and unblemished except for three little moles that formed a triangle above her hip bone. Her breasts were small but exquisite—more beautiful than the marble statues he’d seen in Italy.")])]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It had been a long time since he’d been with a naked woman. Nearly half a year. Before he shipped out for the front lines. Before he’d been wounded.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The woman he held in his arms groaned. Her head lifted for a moment before lolling forward. He tugged one of his army-issued T-shirts over her head and shoulders, then stretched her out on the bed and pulled up the covers to her chin.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Sitting beside her on the edge of the bed, he held her wrist to check her pulse. The beat was steady and stable; she was going to be all right after she warmed up. Though she’d taken one hell of a fall, she had no broken bones. Tomorrow, she’d feel the bruises.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her nose wiggled as she stirred in her sleep. Then she sighed and went quiet again. She was beautiful, a regular sleeping beauty. Her thick black hair framed her face. Delicate eyebrows arched above her full lashes. Her best feature was her full, pouty lips. She had the kind of mouth that begged to be kissed.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("When he’d rescued her from the blizzard, she’d looked like hell with snow matting her hair, her complexion drained and her lips tinged with blue. What had she been doing out here? This wasn’t a sanctioned area; she shouldn’t have been up here, but he was glad she’d broken the rules. This pretty lady—whoever she was—made a good diversion.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_vm._v("Only a few hours ago, Luke had received his orders to return to the front lines of battle. In less than ")]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_vm._v("a week, he’d be shipped back to hell. He wasn’t a coward, but the order scared him. He remembered too well. Too many scenes of carnage were burned in his memory. When he closed his eyes, he saw the blood and the devastation. Buildings shattered. People torn apart. His ears still echoed with the cries of dying men and women. He felt the pain of his own wounds and relived the moment when he had been shot, when he saw his own death and welcomed it.")])]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He didn’t want to go back. Except for one thing.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He glanced toward the snapshot on the table. A picture of an eight-year-old boy with thick, curly black hair. His skinny chest thrust proudly as he waved to the camera. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Roberto.")]), _vm._v(" Though Luke needed no reminder of the boy, he always carried that photo with him. He’d made a promise to Roberto. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("I’ll come back for you.")]), _vm._v(" That solemn vow was more important to him than the war or his dedication to the 10th Mountain Division or even his own survival. Roberto was the reason Luke would return to the front. Though it seemed impossible to find one small boy among the multitude of orphans left by the war, he had to try.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("When Luke came to the cabin tonight, he’d been hoping to find his sense of purpose. Because he was going to need every bit of his strength and courage to find Roberto and make everything turn out okay, he needed a reason to believe in himself again. And the storm had brought this strange woman to him.")])]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He hadn’t noticed her on the slope until he heard a yelp and saw her crashing out of control. She’d been a long way uphill from where he’d been standing, and he had to backtrack and circle around before he could reach her. She was damned lucky that he’d shown up when he did.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He’d saved her life. The odds against him being nearby at the exact moment when she crashed were a million to one. And if he hadn’t been here, she would have frozen to death in this freak spring blizzard. Lucky for her. And for him, too.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The fact that he’d been there—at the right place and in the right time to save her—gave him satisfaction. It was almost enough to renew his spirit, almost enough to make him believe in the possibility of redemption.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Leaving her bedside, he went to the table and poured a double shot of Jack Daniel’s into a mug. Holding the cup aloft, he toasted her. “Here’s looking at you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She groaned. Her eyelids fluttered.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Luke savored his whiskey and waited patiently.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("When she finally wakened, she bolted upright to a sitting posture. Her dark brown eyes were huge and luminous. “Where am I?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“One of the mountain huts constructed by the 10th Mountain Division.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_vm._v("Though she nodded in apparent understanding, he saw confusion in her rapidly darting gaze. Her lips ")]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_vm._v("worked before forming words. “I’ve always wanted to stay in one of these huts. It’s almost impossible to get a reservation.”")])]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Though her words didn’t make sense—a reservation?—she was relatively coherent. He nodded toward a cup of water on a chair beside the bed. “You should drink something.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Right. I’m probably dehydrated.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As she sipped the water, his gaze went again to those full, ripe lips. His temperature rose. The memory of her lush naked body lingered in his mind.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He reached for the opened pack of Lucky Strike cigarettes on the table. “Smoke?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I quit, but I don’t mind if you do. You’re Luke. Is that right?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He nodded. “And you are?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Shana Parisi.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Nice to meet you, Shana Parisi.” He liked the way her name rolled off his tongue. “How are you feeling?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Fine, except for the headache from hell.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I assessed your physical condition. Your vitals are strong. I got you warmed up before you went into hypothermia, but you probably have altitude sickness. I’m guessing you haven’t been at this elevation for more than a day or two.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Your guess is correct.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Where are you from?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Most recently, Kuwait. Before that, Thailand.”")])]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He hadn’t expected that response. Kuwait? Thailand? She was turning into a very interesting diversion. “What brings you to Colorado?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("With a frown, she rubbed at her temple. “I’m a geologist. I work for AMVOX Oil, and we’re looking into an oil shale operation on the western slope.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("A geologist.")]), _vm._v(" That explained the rock samples he’d found in her pockets. Luke finished off the dregs of his Jack Daniel’s, glad for the whiskey warmth that spread through him and lightened his mood. He sure as hell hadn’t expected to be smiling tonight.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She eyed him curiously. “You knew exactly what was wrong with me. Are you a doctor?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Trained as a medic,” he said. “But it wasn’t a complicated diagnosis to figure out that somebody who was turning into a human Popsicle might be going into hypothermia.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“When does the headache go away?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“After a couple of aspirin. First, you need to eat something to elevate your blood sugar.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He crossed the two steps from the table to the bed and held out a Baby Ruth. When she took it from him, their hands touched. An electric spark shot up his arm.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She’d felt it, too. A gasp escaped her lips. Her dark brown eyes widened in surprise.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Thank you,” she whispered. “For the chocolate.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_vm._v("Shana couldn’t quite believe the explosion of energy and awareness that came when they acciden")]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_vm._v("tally touched. That electric sensation was almost enough to make her forget that her head ached and her body was stiff and sore. Luke Rawlins was quite a man.")])]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Immediately she knew that she needed to be careful around him. He reminded her of a lot of the guys she’d worked with on exploration and drilling sites. They fancied themselves to be superstuds, and she’d learned long ago to keep her distance. She didn’t want to be just another notch on the bedpost.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Purposefully, she looked away from Luke and concentrated on the tangible facts. She was glad to be here and to be warm, blessedly warm. A cast-iron potbellied stove stood near the door where their parkas hung on hooks. There were no extra frills in this small, one-room cabin lit by the amber glow of lanterns. A hut. She knew a bit about this system of simple log cabins that had been constructed in the 1940s by the 10th Mountain Division. In Leadville, there were dozens of memorials to these World War II heroes. “Didn’t you say that you were with the 10th Mountain Division?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“That’s right.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Those guys were supposed to be the best skiers, mountain climbers and sharpshooters in the world. Elite commandos.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“We still are.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_vm._v("As she peeled the wrapper off her Baby Ruth, she dared to study this soldier in his army-green fatigues—kind of a weird outfit for somebody who ")]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_vm._v("was on vacation at a mountain hut. But she was willing to excuse this minor eccentricity. The man had saved her life. Also, he was remarkably good-looking with deep-set blue eyes and the tanned complexion of an outdoorsman. His brown hair was short in a no-nonsense military cut that worked for him. She guessed that he was in his early thirties. If she’d been in the market for a man, he’d be the right age.")])]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But she wasn’t looking. Or was she? There was a sense of destiny about being here, being with him. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Destiny? Yeah, sure.")]), _vm._v(" She believed in science, not kismet. Trying to ignore the twinges of pain inside her head, she nibbled at her candy bar and sipped the water. Rehydration was important.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He tapped a cigarette from the pack, flipped open a Zippo lighter and lit up. Though she hated the tobacco smell, she was pleased. The fact that he had at least one disgusting habit was proof that he wasn’t perfect. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Not the right guy for me.")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("When he stood, she realized how tall he was—at least four inches over six feet. His body was lean but muscular with square shoulders, and he was obviously in excellent condition. Even in his poorly fitted fatigues, his muscular thighs bulged.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I should thank you again,” she said. “You saved my life.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“My pleasure.” He went to the potbellied stove, opened the latched door and laid another piece of wood on the fire.")])]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("His pleasure?")]), _vm._v(" A shiver of awareness rippled through her. Beneath the quilts and blankets on the bed, she wore nothing but an oversize olive-drab T-shirt. Near the door, she saw her ski pants and her turtleneck hung up to dry. But she didn’t remember getting undressed. Her fingers plucked at the cotton fabric of T-shirt. “Is this yours?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I had to strip off those wet clothes so you could warm up. But don’t worry. I kept my eyes closed.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Stripped naked by a stranger. She should have been humiliated, wildly embarrassed. Kept his eyes closed? "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Yeah, right.")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("When she gazed accusingly into his coolly assessing blue eyes, she saw a hint of approval. Then he grinned. Apparently, he’d been pleased by what he’d seen when he changed her clothes.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("In normal circumstances, she would have lashed out, making it very clear that he would never ever see her naked again. Instead, a lovely warmth blossomed inside her. She could do a lot worse than being swept off her feet by Luke Rawlins. “I’ll have that aspirin now.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He tossed her a small glass bottle and returned to the chair where he sat and stretched out his long legs. Leaning back, he took a puff on his cigarette and exhaled a cloud of blue smoke.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_vm._v("Slightly mesmerized, she watched. He even made smoking look sexy. Quickly, she gulped down three aspirin. She really ought to get out of here before she ")]), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_vm._v("did something she’d regret. Like throwing herself into his arms. Or ripping off her T-shirt. Or, better yet, tearing off his clothes piece by piece. “I should go now. I’ve already imposed too much on your hospitality.”")])]), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It’s late, Shana. Almost dark. You’re going nowhere tonight.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She peered through the frost-rimed glass of the only window in the cabin. Outside, it was heavy and gray but the blizzard seemed to have stopped. She was aware of the wind whistling through the branches of the pine trees and sweeping against the log walls of the cabin. “Do you have a car? Or a snowmobile? Some kind of transportation?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Just my skis.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Maybe I could call for help. Do you have my pack?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He went toward the door, picked up her pack and set it on the bed beside her. She sifted through the contents until she found her cell phone, which was totally dead. “Broken. I must have landed on it when I fell.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She was stranded. Tucked away in a cozy, warm cabin with the sexiest man she’d ever seen. This felt like a fantasy. A dream. But he was here and real—far too potent to vanish when she blinked her eyes.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_vm._v("Needing to assess the situation, she threw off the blankets and climbed out of the bed. In a few strides, she crossed to the door and pulled it open. A blast of ")]), _c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_vm._v("cold hit her bare legs. Though the snow had stopped, a drift came all the way up to the cabin’s door and trickled inside. They were in the forest at the edge of a clearing. She saw no sign of other houses. No lights. No roads. Nothing but complete isolation.")])]), _c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Luke came up behind her and shoved the door closed. “You’re here for the night.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("When she looked up into his face, she didn’t want to leave. Wearing only his T-shirt, she should have been cold. Instead, a glowing heat churned through her veins. Strange. She was light-headed, oddly disconnected.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He touched her forehead. “You’re hot.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“So are you,” she said. “If we rub together, maybe we’ll start a forest fire.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A smile lifted the corner of his mouth. “I meant to say that you might have a fever.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“But I don’t feel sick. Not really sick.” But not herself. Her common sense seemed to have vanished, whisked away by the swirling snows on the mountain. She’d been transported to a magical place where normal concerns and hesitations did not apply.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Reaching out, she placed her palm flat against his chest. Through his army fatigues, she felt the steady, strong beating of his heart. The rhythm echoed through her and synchronized perfectly with her own pulse—two hearts beating as one. She was a part of him. Inseparable and needing a deeper connection.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She tilted her chin up. Her lips parted.")])]), _c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("When he kissed her, he took his time. She tasted whiskey on his mouth. Slowly, he deepened the kiss.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His arms surrounded her, supporting her. His body pressed against hers. She seemed to rise off the floor, floating on a cloud. A spiral of tingling sensation unfurled and spread from her head to her heart to every intimate part of her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("When his lips left hers, she gazed up at his ruggedly handsome face. Her vision went hazy. Her headache became a steady pulse. Throbbing, but not painful.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She couldn’t believe this was really happening. A strong, gorgeous man had appeared from nowhere to sweep her into his arms and rescue her from certain death. He was her knight in shining ski gear.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Though she barely had the strength to stand, she knew his strong arms would never let her fall. Dazed and in shock, she abandoned herself to this swirling fantasy.")])])]), _c('a', {
    attrs: {
      "id": "page22"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page22"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b5344d8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781459222458_ch01.vue
// module id = 78
// module chunks = 0